import { Component, ElementRef, ViewChild, Inject, ViewEncapsulation } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Settings } from 'src/app/app.settings.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppOAuthStore } from 'src/app/models/AppOAuthSotarge';
import { DialogConfirmacion } from '../dialogs/confirmacion/dialogConfirmacion.component';
import { httpConnect } from 'src/app/services/httpConnect.service';
import { SocorrosContacto } from 'src/app/models/Socorros/SocorrosContacto';
import { CatalagosConfig } from 'src/app/models/CatalogosConfig';

@Component({
    selector: 'dialog-add-contacto',
    templateUrl: './catAutocompleteAddContacto.component.html',
    styleUrls : ['./catautocomplete.component.scss'],
    encapsulation: ViewEncapsulation.None
  })
  
  export class DialogCatACContacto {
    settings: Settings;
    private connectSvc;
    public contacto: SocorrosContacto = new SocorrosContacto();
    public catConfig: CatalagosConfig = new CatalagosConfig;
    public institucionList = [];
    public institucionSelected: any;
    constructor(
      public dialogRef: MatDialogRef<DialogCatACContacto>,
      private dialog: MatDialog,
    //   private toastaService:ToastaService,
    //   private toastaConfig: ToastaConfig, 
      private httpCon: httpConnect,
      public myStorage: AppOAuthStore,
      @Inject(MAT_DIALOG_DATA) public data: any
      ) {       
        this.connectSvc = httpCon;
        this.contacto.nombre = data.text;
        this.contacto.cargo = "";
    }
  
    ngOnInit(){
      
    }

    public SetInstitucion(ev:any) {
      this.institucionSelected = ev;
      this.contacto.institucion = ev;
    }

    public MostrarDialogConfirmacion(): void {
        let dialogConf = this.dialog.open(DialogConfirmacion, {
          data: { titulo: "Confirmación", mensaje: "¿Desea guardar la información capturada?", tipo: 2, confirm: false },
          // panelClass: "dialog-responsive-cat",
          disableClose: true,
          });
    
          dialogConf.afterClosed().subscribe(result => {
              if (!!result) {
                  if (result.confirm){
                      this.Add();
                  }     
              }      
          });
    }

    public Add() {
        let params = this.contacto;
          this.connectSvc.postAPI("General", "SetCatalogos_NuevoContacto", params)
          .subscribe(result => {
              let res = result.response;
              this.dialogRef.close(res[0]);
           }, err => {
              //this.fcToasta.ShowToasta(err.error.Message, EnumToastaType.Error)
            }
          )
         
    }
  
    onNoClick(): void {
      this.dialogRef.close({});
    }
  }